module.exports = __webpack_public_path__ + "img/numbersOrderOff.2c3cdc47.svg";